//fake enum for body part IDs

import {AID} from '../enums/AccessoryIdEnum.js';
export const AccessoryNames = {

    [AID.HAT]: "Hoed",
    [AID.SLEEVE_LEFT]: "Mouw",
    [AID.SLEEVE_RIGHT]: "Mouw",
    [AID.SHIRT]: "Shirt",
    [AID.SHOE_LEFT]: "Schoenen",
    [AID.SHOE_RIGHT]: "Schoenen",
    [AID.HAND]: "Gadget",
    [AID.PANTS]: "Broek",
    'colors': "Kleuren"


}